import React, { useEffect } from "react";
// import registrationProcess from "web/assets/images/HowItWorksYouTubeLogos/registration-process.svg";
// import accountSetup from "web/assets/images/HowItWorksYouTubeLogos/account-setup.svg";
// import claimResolutionReport from "web/assets/images/HowItWorksYouTubeLogos/claim-resolution-report.svg";
// import createManageCommunity from "web/assets/images/HowItWorksYouTubeLogos/create-manage-community.svg";
// import placeReviewBidsOffer from "web/assets/images/HowItWorksYouTubeLogos/place-review-bids-offer.svg";
// import manageUserAndLocation from "web/assets/images/HowItWorksYouTubeLogos/manage-user-and-location.svg";
// import needAndInventory from "web/assets/images/HowItWorksYouTubeLogos/need-and-inventory.svg";
import CommonYtTag from "web/assets/svg/YoutubeIcon";

import AOS from "aos";
// import { useHistory } from "react-router-dom";

import {
  Container,
  Wrapper,
  GroupSection,
  BoxSection,
} from "web/pages/public/landing-page/HowItWork/HowItWorkUrls/HowItWorksUrlsStyled";
import { FaHandPaper } from "react-icons/fa";


const Data = [
  {
    id: 1,
    heading: "Get Started With Registration.",
    videoUrl: "https://www.youtube.com/watch?v=XC7jOf0Q684",
    subHeading:
      "Sign up, set your preferences, and you’re ready to join the PalletTrader community.",
    // src: "commonYtTag",
  },
  {
    id: 2,
    heading: "Account Set-Up - Personalize Your User Experience.",
    videoUrl: "https://www.youtube.com/watch?v=Fcxn8etvaQs",
    subHeading:
      "From sizes and styles of pallets, and types of transactions, to the data and analytics for tracking success, you’re in control.",
    // src: `${commonYtTag}`,
  },
  {
    id: 3,
    heading: "Manage Users & Locations.",
    videoUrl: "https://www.youtube.com/watch?v=Pyw2QKklz_E",
    subHeading:
      "Use it for your single location, or create a nationwide network by simply adding sites.Under “Create and manage” video window.",
    // src: `${commonYtTag}`,
  },
  {
    id: 4,
    heading: "Create & Manage “My Community” Groups.",
    videoUrl: "https://www.youtube.com/watch?v=SxJfVwATUrE",
    subHeading:
      "Buy and sell in the public marketplace, or create a private area to conduct business with current partners and suppliers.",
    // src: `${commonYtTag}`,
  },
  {
    id: 5,
    heading: "Create Posts of Pallet Inventory or Pallet Needs.",
    videoUrl: "https://www.youtube.com/watch?v=OpSUepfAkR4",
    subHeading:
      "Buy and sell, view active posts, or review your bids and offers in the marketplace. Under “Placing and reviewing” video window.",
    // src: `${commonYtTag}`,
  },
  {
    id: 6,
    heading: "Placing & Reviewing Bids or Offers.",
    videoUrl: "https://www.youtube.com/watch?v=cgCvAYP3xrA",
    subHeading:
      "Whether you’re a buyer or seller, you’ll find everything you need to review and accept your bids and offers.",
    // src: `${commonYtTag}`,
  },
  {
    id: 7,
    heading: "Claim Resolution and Report Center",
    videoUrl: "https://www.youtube.com/watch?v=9Pem-jdLG8c",
    subHeading:
      "Find everything you’ll need to resolve questions or concerns, and manage your end-of-the-month accounting needs.",
    // src: `${commonYtTag}`,
  },
];

const HowItWorksUrls = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 320,
    });
  }, []);
  return (
    <Container data-aos="fade-up" data-aos-delay="400">
      <Wrapper>
        <h4>Take a look at the tool the industry has waited 100 years for.</h4>
        <h5>
          For more than a century, the pallet industry has used the same tools to manage supply.
          The rest of the business world has long since moved on to more efficient, effective technologies for communication.
          It’s time pallet buyers and sellers had the best tools to conduct business, too.
        </h5>
        <GroupSection>
          {Data.map((e) => {
            return (
              <BoxSection key={e.id}>
                <a target="_blank" href={e.videoUrl} className="banner-wrapper">
                  {/* <img src={e.src} alt="icons" /> */}
                  <p className="inner-text">{e.heading}</p>
                  <CommonYtTag className="youtube-icon" />

                </a>
                <h6>{e.heading}</h6>
                <p>{e.subHeading}</p>
                <a target="_blank" href={e.videoUrl}>
                  Watch Demo
                </a>


              </BoxSection>
            );
          })}
        </GroupSection>
      </Wrapper>
    </Container >
  );
};

export default HowItWorksUrls;
